export default __webpack_public_path__ + "static/media/host_mute.c6000526.svg";